import BlockCaseHero from './BlockCaseHero';

export type { BlockCaseHeroProps, ScrollerProps, TagsProps, Tag } from './types';

export default BlockCaseHero;
